(() => {
  const GENERIC_SECTION_SELECTOR = '[id^="vh-product-info-"]';

  function closestElement(target, selector) {
    return target instanceof Element ? target.closest(selector) : null;
  }

  function closeGenericGallery(gallery) {
    if (!(gallery instanceof HTMLElement)) return;

    const image = gallery.querySelector('[data-vh-benefit-gallery-img]');
    gallery.hidden = true;

    if (image instanceof HTMLImageElement) {
      image.src = '';
      image.alt = '';
    }

    if (!document.querySelector('[data-vh-benefit-gallery]:not([hidden])')) {
      document.documentElement.style.overflow = '';
    }
  }

  function openGenericGallery(button) {
    const section = button.closest(GENERIC_SECTION_SELECTOR);
    if (!section) return;

    const gallery = section.querySelector('[data-vh-benefit-gallery]');
    const image = gallery?.querySelector('[data-vh-benefit-gallery-img]');
    const src = button.getAttribute('data-vh-benefit-image');

    if (!(gallery instanceof HTMLElement) || !(image instanceof HTMLImageElement) || !src) return;

    image.src = src;
    image.alt = button.getAttribute('data-vh-benefit-alt') || '';
    gallery.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function toggleSpecs(button) {
    const wrap = button.closest('[data-vh-specs]');
    if (!wrap) return;

    if (button.getAttribute('data-vh-specs-prepared') !== 'true') {
      wrap.querySelectorAll('[data-vh-spec-item].is-hidden').forEach((item) => {
        item.setAttribute('data-vh-spec-collapsible', 'true');
      });
      button.setAttribute('data-vh-specs-prepared', 'true');
    }

    const items = wrap.querySelectorAll('[data-vh-spec-collapsible="true"]');
    if (!items.length) return;

    const isOpen = button.getAttribute('data-open') === 'true';

    items.forEach((item) => {
      item.classList.toggle('is-hidden', isOpen);
    });

    button.setAttribute('data-open', isOpen ? 'false' : 'true');
    button.textContent = isOpen ? 'Pokaż więcej parametrów' : 'Pokaż mniej parametrów';
  }

  function filterFaq(input, config) {
    const wrap = input.closest(config.wrapSelector);
    if (!wrap) return;

    const items = wrap.querySelectorAll(config.itemSelector);
    if (!items.length) return;

    const query = input.value.toLowerCase().trim();
    let visibleCount = 0;

    items.forEach((item) => {
      const visible = item.textContent.toLowerCase().includes(query);
      item.style.display = visible ? '' : 'none';
      if (visible) visibleCount += 1;
    });

    const empty = wrap.querySelector(config.emptySelector);
    if (empty instanceof HTMLElement) {
      empty.hidden = visibleCount > 0;
    }
  }

  document.addEventListener('click', (event) => {
    const openButton = closestElement(event.target, '[data-vh-benefit-gallery-open]');
    if (openButton) {
      openGenericGallery(openButton);
      return;
    }

    const closeButton = closestElement(event.target, '[data-vh-benefit-gallery-close]');
    if (closeButton) {
      const gallery = closeButton.closest('[data-vh-benefit-gallery]');
      closeGenericGallery(gallery);
      return;
    }

    const specsButton = closestElement(event.target, '[data-vh-spec-toggle]');
    if (specsButton instanceof HTMLElement) {
      toggleSpecs(specsButton);
    }
  });

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    if (target.matches('[data-vh-faq-search]')) {
      filterFaq(target, {
        wrapSelector: '[data-vh-faq]',
        itemSelector: '[data-vh-faq-item]',
        emptySelector: '[data-vh-faq-empty]',
      });
      return;
    }

    if (target.matches('[data-vh-sofa-faq-search]')) {
      filterFaq(target, {
        wrapSelector: '[data-vh-sofa-faq]',
        itemSelector: '[data-vh-sofa-faq-item]',
        emptySelector: '[data-vh-sofa-faq-empty]',
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-vh-benefit-gallery]:not([hidden])').forEach((gallery) => {
      closeGenericGallery(gallery);
    });
  });
})();
